import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import DashboardTable from "./DashboardTable";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontWeight: "700",
    color: theme.palette.text.secondary,
  },
  subtitle: {
    fontSize: "20px",
    fontWeight: "700",
    color: theme.palette.text.secondary,
  },
  container: {
    backgroundColor: "white",
    marginTop: "3rem",
    borderRadius: "8px",
  },
}));

function Dashboard() {

  const classes = useStyles();
  return (
    <Box>
      <Typography className={classes.heading} variant="h2">
        All Pools
      </Typography>
      <Box className={classes.container} p={4}>
        <Typography className={classes.subtitle} variant="subtitle1">
          Pool List
        </Typography>
        <DashboardTable />
      </Box>
    </Box>
  );
}

export default Dashboard;
